import request from '@/utils/request'

export function listLogSwitch() {
  return new Promise((resolve, reject) => {
    request({
      url: '/logSwitch.listLogSwitch',
      method: 'post',
      data: {}
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateLogSwitch(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/logSwitch.updateLogSwitch',
      method: 'post',
      data: data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
